import Head from 'next/head';
import { NextSeo } from 'next-seo';
import Career from '@cont/Careers';
import CareersPageLayout from '@layout/CareersPageLayout';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const CareerLandingPage = () => {
  const title = 'Careers | Unacademy';
  const url = 'https://unacademy.com/careers';
  const description =
    'Let’s build the future of education together. Come, join us and together we can transform the way India learns.';

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        url={url}
        openGraph={{ title, description, url }}
      />
      <Head>
        <title>{title}</title>
      </Head>
      <Career />
    </>
  );
};

CareerLandingPage.Layout = CareersPageLayout;

CareerLandingPage.pageInfo = {
  name: 'Unacademy Careers',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

CareerLandingPage.getInitialProps = setupInitialProps(
  null,
  CareerLandingPage.pageInfo
);

export default CareerLandingPage;

CareerLandingPage.propTypes = {};
CareerLandingPage.Wrapper = PageReduxProvider;
